import { themeAtom } from "../../../shared/atoms";
import type { AdminCrewReportRequestConfirmationModalProps } from "../../models/admin-crew-report.models";
import { adminStyles } from "../../styles/admin.styles";
import { getCrewReportSendConfirmationMessage } from "../../utils/admin-crew-report.utils";
import { Dialog } from "@headlessui/react";
import { useAtomValue } from "jotai";
import { useRef } from "react";
import { twMerge } from "tailwind-merge";

const AdminCrewReportRequestConfirmationModal = ({
  vesselName,
  recipientEmail,
  onClose,
  onConfirm,
}: AdminCrewReportRequestConfirmationModalProps) => {
  const theme = useAtomValue(themeAtom);
  const closeButtonRef = useRef<HTMLButtonElement | null>(null);
  const confirmationMessage = getCrewReportSendConfirmationMessage(vesselName, recipientEmail);

  return (
    <Dialog
      as="div"
      open
      initialFocus={closeButtonRef}
      onClose={onClose}
      data-test="admin-crew-report-request-confirmation-modal"
      className="fixed inset-0 z-50"
    >
      <Dialog.Overlay
        className="fixed inset-0 bg-black/45"
        data-test="admin-crew-report-request-confirmation-backdrop"
        data-testid="admin-crew-report-request-confirmation-backdrop"
      />
      <div className="fixed inset-0 flex items-center justify-center px-3 py-4">
        <Dialog.Panel
          className={twMerge(
            "w-full max-w-lg bg-white px-5 py-5 shadow-2xl dark:bg-gray-800",
            theme.home.tailwind.textDefault,
          )}
        >
          <Dialog.Title className="text-xl font-semibold">Confirm Crew Report request</Dialog.Title>
          <Dialog.Description className="mt-3 text-[13px] leading-6">{confirmationMessage}</Dialog.Description>

          <div
            role="group"
            aria-label="Crew Report request confirmation actions"
            className="mt-6 flex flex-nowrap items-center justify-between gap-2"
          >
            <button
              type="button"
              className={twMerge(adminStyles.button.primary, adminStyles.button.safe, "w-auto")}
              onClick={onConfirm}
            >
              Send
            </button>
            <button
              ref={closeButtonRef}
              type="button"
              className={twMerge(
                adminStyles.button.primary,
                "w-auto border border-green bg-white text-green hover:bg-[#E9F4F3] dark:bg-gray-800 dark:hover:bg-gray-700",
              )}
              onClick={onClose}
            >
              Close
            </button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default AdminCrewReportRequestConfirmationModal;
